module.exports = __webpack_public_path__ + "static/media/slide3.a046956b.webp";